module.exports = __webpack_public_path__ + "img/img_side_flower.1d3a42af.png";